import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { CustomService, ToolsService } from '@app/core/services';
import { ModalComponent } from '@app/core/services/modal-manager/modal-component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-developer-info',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './developer-info.component.html',
  styleUrl: './developer-info.component.scss',
})
export class DeveloperInfoComponent extends ModalComponent {
  protected readonly customService: CustomService = inject(CustomService);
  protected readonly currentFCMToken = toSignal(this.customService.currentFcmToken$);
  private readonly toolsService: ToolsService = inject(ToolsService);

  /**
   * Copies the current FCM (Firebase Cloud Messaging) token to the clipboard.
   * If a valid token is available, it uses the `toolsService` to copy the token
   * and displays a confirmation message to the user.
   *
   * @protected
   */
  protected copyTokenInClipboard(): void {
    if (this.currentFCMToken()) {
      this.toolsService.copyToClipboard(this.currentFCMToken() ?? '', 'Token copied to clipboard');
    }
  }
}
